<template>
    <v-flex xs12>
        <v-layout class="map-wrapper">
            <div v-if="!markers || markers.length == 0">
                <p>No se han encontrado sucursales</p>
            </div>
<!--            <MglMap v-else v-on:load="addBuildings" :accessToken="accessToken" :mapStyle="mapStyle" :center="center" :zoom="13" :bearing="25" :pitch="45">
                <v-layout v-for="(marker, index) in markers" :key="index" >
                    <MglMarker @click="selectedOffice=marker" :coordinates="marker.position" :color="marker.icon.color" >
                        <MglPopup>
                            <v-sheet height="110" class="pa-2">
                                <h1 class="title font-weight-light">{{marker.name}}</h1>
                                <v-divider></v-divider>

                                <v-layout wrap  class="mt-2">
                                    <v-flex xs12  v-for="(detail, i) in marker.details" :key="index+'-'+i" >
                                        <v-avatar size="24">
                                            <v-icon size="16">{{detail.icon}}</v-icon>
                                        </v-avatar>
                                        <span style="max-width: 100px" class="text-truncate" v-html="detail.value"></span>
                                    </v-flex>
                                </v-layout>

                            </v-sheet>
                        </MglPopup>
                    </MglMarker>
                </v-layout>
            </MglMap>-->
        </v-layout>

    </v-flex>
</template>

<script>



    export default{
        props: ['provider'],
        data() {
            return {
                mapbox: null,
                selectedOffice: [10,10],
                accessToken: process.env.VUE_APP_MAPBOX_TOKEN, // your access token. Needed if you using Mapbox maps
                mapStyle: process.env.VUE_APP_MAPBOX_STYLE // your map style
            };
        },
        created() {
            // We need to set mapbox-gl library here in order to use it in template
           /* this.mapbox = Mapbox;*/
        },
        mounted(){
           var  mainOffice = this.markers.find(marker => marker.main)
            if(mainOffice) this.selectedOffice = mainOffice
        },
        computed:{
            center(){

                var vm = this

                if(vm.selectedOffice){
                    return vm.selectedOffice.position
                }

                return [ 10, 10 ]

            },
            markers(){

                var vm = this

                return vm.offices.map(office => {
                    return {
                        position: [Number(office.longitude), Number(office.latitude)],
                        name: office.name,
                        main: office.main,
                        details:[
                            {
                                icon: 'fas fa-phone',
                                value: office.phone1 ? `<a href='tel:${office.phone1}'>${office.phone1}</a>` : '-'
                            },
                            {
                                icon: 'fas fa-phone',
                                value: office.phone2 ? `<a href='tel:${office.phone2}'>${office.phone2}</a>` : '-'
                            },
                            {
                                icon: 'fas fa-map-marker-alt',
                                value: (office.address || '-')
                            },
                        ],
                        icon: {
                            name: 'fas fa-building',
                            color: office.main ? 'primary' : 'accent'
                        },
                    }
                })

            },
            offices(){
                var vm = this
                if(!vm.provider || (!vm.provider.institution && !vm.provider.user)) return []
                const provider = vm.provider.institution || vm.provider.user

                return provider.branch_offices || []
            }
        },
        methods:{
            onMarkerClick(office){

            },
            addBuildings({map}){

            }
        }
    }
</script>

<style scoped>
    .map-wrapper{
        height: 300px;
        position: relative;
        overflow: hidden;
    }
</style>